import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import FCSlider from '../../fc_slider/fc_slider';
import Ad from '../../ad/ad';

export default class Article extends Component {
  constructor() {
    super();

    this.mobileAdIndex = 0;
  }

  shouldComponentUpdate() {
    return false;
  }

  setPostChunk(chunk, index) {
    let markup = chunk.join('');

    if (markup === 'INLINE_CAROUSEL') {
      return (
        <FCSlider
          slideShowData={this.inlineCarousels.shift()}
          location="post__inline"
        />
      );
    }

    const { post, isShortPost } = this.props;
    const totalChunkIndexes = post.content && post.content.length - 1;

    if (totalChunkIndexes === index && isShortPost) {
      const { slug, initials } = post.author;
      const authorMarkup = `<a class="post__initials" href="/user/${slug}">${
        initials
      }</a>`;
      const lastClosePpos = markup.lastIndexOf('</p>');
      const lastIframe = markup.substr(markup.length - 13) === `</iframe></p>`;

      if (lastClosePpos + 4 === markup.length && !lastIframe) {
        markup = `${markup.substring(0, lastClosePpos) + authorMarkup} </p>`;
      } else {
        markup += `<p>${authorMarkup}</p>`;
      }
    }

    return <div dangerouslySetInnerHTML={{ __html: markup }} />;
  }

  setMobileAdName(index) {
    let adName;
    const adMap = { 0: 'mobileparallax_1', 3: 'mobileparallax_2' };

    if (Object.prototype.hasOwnProperty.call(adMap, index)) {
      adName = adMap[index];
    } else {
      adName = `mobilerectangle_${(this.mobileAdIndex += 1)}`;
    }

    return adName;
  }

  notAroundCarousel(chunks, currentChunk, index) {
    const next = chunks[index + 1] || [];
    const nextZeroIndex = next[0];
    const carousel = 'INLINE_CAROUSEL';

    if (nextZeroIndex === carousel || currentChunk === carousel) {
      return false;
    }

    return true;
  }

  render() {
    const { post, pageNum, combinedAdModel, isShortPost } = this.props;

    const chunks = post.content;

    this.inlineCarousels = cloneDeep(get(post, 'inlineCarousels')) || [];

    if (post.isVideoPermalink) {
      return (
        <article className="post__article">
          <p>{post.excerpt}</p>
        </article>
      );
    }

    return (
      <article className="post__article">
        {chunks.map((chunk, index) => [
          this.setPostChunk(chunk, index),
          !isShortPost &&
          index < chunks.length - 1 &&
          this.notAroundCarousel(chunks, chunk[0], index) ? (
            <Ad
              {...combinedAdModel}
              pos="btf"
              pageNum={pageNum}
              name={this.setMobileAdName(index)}
            />
          ) : (
            ''
          )
        ])}
      </article>
    );
  }
}

Article.propTypes = {
  post: PropTypes.shape({}).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  pageNum: PropTypes.number.isRequired,
  isShortPost: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/views/components/post/content/article.js